import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cost-of-living',
  component: () => import('../../routes/CostOfLiving.svelte'),
  card: {
    id: 'cost-of-living',
    title: 'Cost of Living Comparison',
    description: 'Compare monthly expenses between two cities or regions across housing, food, transportation, and more.',
    icon: 'compare_arrows',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/cost-of-living',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Cost of Living Comparison Calculator – Compare Expenses Between Cities',
    description: 'Free cost of living comparison calculator. Compare monthly expenses between two cities or regions across housing, food, transportation, healthcare, utilities, and more. See side-by-side breakdowns and find out how much you could save by relocating.',
  },
};

export default meta;
